import Box from "@mui/material/Box"
import { AutoField, useField } from "@w3rone/json-schema-form"
import type { FieldComponentProps } from "@w3rone/json-schema-form"

export const ReportQuestionPhotoCollectionField = ({
  name,
}: FieldComponentProps) => {
  const { value } = useField(name)

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, 1fr)", lg: "1fr" },
        gap: 2,
      }}
    >
      {Array.isArray(value)
        ? value.map((_item, index) => (
            <AutoField key={`${name}[${index}]`} name={`${name}[${index}]`} />
          ))
        : null}
    </Box>
  )
}
